import {
    SAVE_PORTAL_REGISTRATION,
    SAVE_PORTAL_REGISTRATION_SUCCESS,
    PORTAL_REGISTRATION_ERROR,
    RESET_PORTAL_REGISTRATION_STATE,
  } from "./actionType";
  
  const INIT_STATE = {
    PostData: { Status: false },
    saveBtnLoading: false,
  };
  
  const PortalRegistrationReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
  
      //  SAVE
      case SAVE_PORTAL_REGISTRATION:
        return {
          ...state,
          saveBtnLoading: true,
        };
  
      case SAVE_PORTAL_REGISTRATION_SUCCESS:
        return {
          ...state,
          PostData: action.payload,
          saveBtnLoading: false,
        };
  
      // ERROR
      case PORTAL_REGISTRATION_ERROR:
        return {
          ...state,
          saveBtnLoading: false,
        };
  
      // RESET
      case RESET_PORTAL_REGISTRATION_STATE:
        return {
          ...state,
          PostData: { Status: false },
          saveBtnLoading: false,
        };
  
      default:
        return state;
    }
  };
  
  export default PortalRegistrationReducer;